import React from 'react'

import type { StoryWithKeyIndicatorsCategoriesStoryImageAndResources } from '@aqua/db/types'

const StoryResources = ({
  storiesData,
}: {
  storiesData: StoryWithKeyIndicatorsCategoriesStoryImageAndResources
}) => {
  return (
    <div className='h-max w-full'>
      <h2 className='mb-6 text-[16px] font-bold'>Resources</h2>
      {storiesData.doiResource && (
        <a
          target='_blank'
          className='text-wrap text-primary text-left text-[16px]  font-semibold leading-6 underline'
          href={storiesData.doiResource}
          rel='noreferrer'
        >
          {storiesData.doiName}
        </a>
      )}
      <ul className='marker:text-primary mt-5 flex h-full w-full list-disc flex-col  pl-10'>
        {storiesData.storyResources.map((resource, index) => {
          return (
            <li key={index}>
              <a
                target='_blank'
                rel='noreferrer'
                className='text-wrap text-primary text-left text-[16px] font-semibold  leading-6 underline'
                href={resource.link ?? undefined}
              >
                {resource.name}
              </a>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default StoryResources
